export default "__VITE_ASSET__Dhgo6zqE__"